import { HashLink } from 'react-router-hash-link';
import './index.css'

function Intro() {
    return (      
      <div className='intro_block'>
        <div className='headline'>Application development and maintenance</div>        
        <div className='description'>Software Development, System Integration and Platform Maintenance</div>
        <div className='button'>
          <HashLink smooth to='/#contact'>
            <div className='contactBtn'>Contact Us</div>
          </HashLink>          
        </div>
      </div>      
    )
}

export default Intro;